'use strict';

var HeaderLabel = function HeaderLabel(options) {
	var label = this,
	    update = function update() {
		label.updateSerie.apply(label, arguments);
	};

	label.userOptions = options;
	label.cnt = $('<div class="iChart-headerLabel"></div>');

	label.options = {};
	HeaderLabel_type.call(this, options, update);
	HeaderLabel_interval.call(this, options, update);
	HeaderLabel_calendar.call(this, options, update);
	if(!isMobile){
		HeaderLabel_annotations.call(this, options);
	}
};

HeaderLabel.prototype = {

	setSerie: function setSerie(serie, cdata, gCtx) {

		var _this = this;
		var nSeries = nSeriesGlobal = Object.keys(cdata.series).length;
		this.serie = serie;

		//update container
		this.cnt.empty();

		if (this.interval) {
			this.interval.remove();
			//this.type.remove();
		}

		var seriesIdentifier = "";

		if(cdata.bs.split(',')[0] == serie.options.id){
			var treatedShortName = serie.options.shortname
			let searchPlaceholder = !isMobile? "Search..." : "Search"
			// if (serie.options.db_type && serie.options.shortname && searchPlaceholders[serie.options.db_type]) {
			// 	const placeholderArr = searchPlaceholders[serie.options.db_type].filter((item) => {
			// 		return item["symbol"].toLowerCase() != serie.options.id.toLowerCase() && item["symbol"].toLowerCase() != _th.userConfig.cdata.bs.toLowerCase()
			// 	})
			// 	if (placeholderArr.length > 0) {
			// 		searchPlaceholder = placeholderArr[0]["name"]
			// 	}
			// }
			if(treatedShortName.length > 11){
				treatedShortName = treatedShortName.split('')
				if(isMobile && window.matchMedia("only screen and (max-width: 480px)").matches){				
						treatedShortName = treatedShortName.splice(0,11)
				}else{
					treatedShortName = treatedShortName.splice(0,23)
				}

				if(treatedShortName.length == serie.options.shortname.length){
					treatedShortName = treatedShortName.join('') 	
				}else{
					treatedShortName = treatedShortName.join('') + '...'	
				}
			}
			
			if(isDarkMode == true){
				var name = _this.name = $('<div title="Search" class="expand-search iChart-header-option dark-iChart-headerLabel-name-input topnav-left-group disableClick" style="background-color:black;">'  + `<span class="searchIcon">${!isMobile? SVG_ICONS["search"] : SVG_ICONS["search_mobile"]}</span>` + seriesIdentifier + '<span class="dark-expand-search-span" style="float:left;"> ' + searchPlaceholder /*(treatedShortName || serie.options.id.split(':')[0].toUpperCase() || serie.options.fullname)*/ + '</span></div>')
			}else{
				var name = _this.name = $('<div title="Search" class="expand-search iChart-header-option iChart-headerLabel-name-input topnav-left-group disableClick" >' + `<span class="searchIcon">${!isMobile? SVG_ICONS["search"] : SVG_ICONS["search_mobile"]}</span>` + seriesIdentifier + '<span class="expand-search-span" style="float:left;"> ' + searchPlaceholder /*(treatedShortName || serie.options.id.split(':')[0].toUpperCase() || serie.options.fullname)*/ + '</span></div>')
			}

			// if(isMobile){
			// 	var name = _this.name = $(`<div title="Searchsss" class="expand-search iChart-header-option iChart-headerLabel-name-input disableClick" style="margin-top: -2px;"><span class=${isDarkMode? "dark-svg":""}>${SVG_ICONS["search"]}</span></div>`)
			// }
			
			name.on('click', function (e) {
				e.preventDefault();
				_th.chart.navigationBindings.deselectAnnotation()
				$("#downloadBtn").hide()
				$("#dark-downloadBtn").hide()
				$(".iChart-menu-cnt-labels").hide();
				$(".iChart-headerSearch:first").removeClass("d-none");
				$(".iChart-headerSearch:first").show();
				$("#compareBtn").addClass("d-none");
				$("#dark-compareBtn").addClass("d-none");
				$("#eventsBtn").hide();
				$("#dark-eventsBtn").hide();
				$("#fullscreenBtn").hide();
				$("#dark-fullscreenBtn").hide();
				$("#expandedSearchBarBoxId").show()
				$("#expandedSearchBarBoxId").focus();
				$('#superMenuBtn').hide()
				$('#dark-superMenuBtn').hide()
				$('.topnav-left-group').hide()
				$("#exportBtn").hide();
				$("#dark-exportBtn").hide();
			});
		}

		var inputGroup = _this.inputGroup = $('<div style="float:left;"></div>').hide();
		_this.input = $('<input type="text" value="' + serie.options.fullname + '" placeholder="' + serie.options.fullname + '">');

		/* new expanded search bar*/
		_this.expandedSearch = $('<div class="iChart-headerSearch d-none searchInput2"><a noref="" id="expandedSBid" class="nav-searchbox-class stickydropdown-toggle" title="Search" style="max-width: 95%; display:block;"><div id="thisIsTheSearchBoxWrapperId2"></div></a></div>').on('click', function (e) {
			_this.input[0].setSelectionRange(0, _this.expandedInput[0].value.length);
		}).hide();
		_this.expandedSearch.on('click', function (e) {
			e.preventDefault()
			e.stopPropagation()
		})
		if(isDarkMode == true){
			_this.expandedInput = $('<input type="text" placeholder="Search..." id="expandedSearchBarBoxId" autocomplete="off" class="dark-nav-search-input-class">').hide();
		}else{
			_this.expandedInput = $('<input type="text" placeholder="Search..." id="expandedSearchBarBoxId" autocomplete="off" class="nav-search-input-class">').hide();
		}



		_this.expandedSearch.find('#thisIsTheSearchBoxWrapperId2').append(_this.expandedInput);

		$('.iChart-headerSearch')[0] ? "" : gCtx.cnt.append(_this.expandedSearch);

		//CLOSES SEARCH FEATURE
		$(document).on("click", function(event){
			if(!$(event.target).closest(_this.expandedSearch).length && $(".iChart-dpMenu-typeahead").is(':visible') && event.target.id !== ('expandedSearchBarBoxId') && event.target.id !== ('compareButtonInputId')){
				gCtx.cnt.children().show();
				_this.expandedSearch.addClass('d-none')
				$("#compareBtn").removeClass("d-none");
				$("#dark-compareBtn").removeClass("d-none");
				$(".compareButtonInput").hide();
				$(".iChart-headerSearch").hide();
				$('#dark-superMenuBtn').show()
				$('#superMenuBtn').show()
				$('.topnav-left-group').show()
				$("#exportBtn").show();
				$("#dark-exportBtn").show();
			}
	});
	$(document).on("keyup", function(event){
		if (event.key == "Escape" && $(".searchInput2").is(':visible')) {
			gCtx.cnt.children().show();
			_this.expandedSearch.addClass('d-none')
			$("#compareBtn").removeClass("d-none");
			$("#dark-compareBtn").removeClass("d-none");
			$(".compareButtonInput").hide();
			$(".iChart-headerSearch").hide();
			$('#dark-superMenuBtn').show()
			$('#superMenuBtn').show()
			$('.topnav-left-group').show()
			$("#fullscreenBtn").show();
			$("#dark-fullscreenBtn").show();
			$('#downloadBtn').show()
			$('#dark-downloadBtn').show()
			$("#exportBtn").show();
			$("#dark-exportBtn").show();
		}
	})

		inputGroup.addClass('iChart-inputGroup');

		_this.expandedInput.typeahead({
			cnt: _this.userOptions.taCnt,
			url: 'https://brains.tradingeconomics.com/v2/search/forex,bond,idx,commodity,mkt?q=',
			//economy,economic,wb,financials,comtrade,fred <= These are not markets
			context: _this.context,
			replace: function replace(url, value) {

				value ? value = value : value = symbol;
				return url + value + '&pp=5&mkchart=1&p=0&_=1566570083316&stance=2';
			},
			onSelect: function onSelect(val) {

				if(val.toLowerCase() != cdata.mainSymbol.toLowerCase()){
					// FIXME: This is duplicated below in documentClick
					cdata.oldSymbol = cdata.mainSymbol;
					cdata.searchSymbol = val.toLowerCase();
					cdata.mainSymbol = val.toLowerCase();
					_this.expandedSearch.animate({ width: '0%' }, 100, function () {
						gCtx.cnt.children().show();
						$(".compareButtonInput").hide();
						$(".searchInput2").hide();
						$(".iChart-menu-cnt-labels").show();
						$("#compareBtn").removeClass("d-none");
						$("#dark-compareBtn").removeClass("d-none");
						_this.expandedSearch.hide();
						_this.expandedInput.hide();
						// $('.topnav-left-group').show()
					});
					var vallow = val.toLowerCase();

					_this.updateSerie('bs', _this.userOptions.chart.series[0].options.id ? _this.userOptions.chart.series[0].options.id : vallow , vallow);
				}

			},
			theme: _this.userOptions.menu.theme,
			onFocus: function onFocus() {
				if (_this.userOptions.onTaFocus) {
					_this.userOptions.onTaFocus();
				}
			},
			events: {
				documentClick: function documentClick(taCnt, taInput) {

					_this.inputGroup.hide();
					_this.name.show();
					taCnt.hide();
				}
			}
		});


		
		//START CALENDAR DATE PICKER
		function dClick(e) {
			e.preventDefault();
			serie.menu.hide();

			ddDArrow.addClass('a-clicked');

			var pos = _this.userOptions.menu.calcDropDownPos(datePickerDiv, _this.options['datePicker'].cnt);
			_this.options['datePicker'].toggle(pos);
		}

		var datePickerDiv = _this.datePickerDiv = div({}, {
			'id': isDarkMode == true ? 'dark-iChartHeader-datePicker-button' : 'iChartHeader-datePicker-button',
			'title':'Custom Dates',
			'class': 'iChart-header-option iChartHeader-button topnav-left-group iChartHeader-datePicker-button d-sm-none-down'
		}).on('click', function (e) {
			_th.chart.navigationBindings.deselectAnnotation()
			dClick(e)
		});
		
		var datePickerSVG = $('<a href="#" id="datePickerSvg" class="iChart-headerTypeSelector iChart-datePickerSelector" style="margin: 0 !important;">' + `${!isMobile? SVG_ICONS[/*'calendar'*/'date_range'] : SVG_ICONS['date_range_mobile']}` + '</a>')

		if(isDarkMode == true){
			datePickerSVG.addClass("dark-svg")
		}

		datePickerDiv.append(datePickerSVG);

		var ddDArrowDiv = _this.ddDArrowDiv = div({}, {
			'class': 'iChart-header-option-small ddDArrowDiv d-none',
		}).on('click', function (e) {
			dClick(e);
		});

		var ddDArrow = _this.ddDArrow = $('<a href="#"></a>');

		ddDArrowDiv.append(ddDArrow);
		$(document).on('click', function (e) { /*Hiding DatePicker Dropdown*/
			const _datePicker = !isDarkMode? document.getElementById('iChartHeader-datePicker-button') : document.getElementById('dark-iChartHeader-datePicker-button')
			const _datePicker_dropDown_arr = Array.from(document.getElementsByClassName('iChart-dpMenu-cnt-date'))
			const not_target_or_parent = _datePicker != e.target && !_datePicker.contains(e.target) && _datePicker_dropDown_arr.every((item) => {
				return item != e.target && !item.contains(e.target)
			})
			if (not_target_or_parent) {
				ddDArrow.removeClass('a-clicked');
				_this.options['datePicker'].hide();
			};

		});
		//fabio
		/*$(document).on('click', function (e) {
			var targetEle = $(e.target)[0];
			if (_this.datePickerDiv[0] != targetEle && !targetEle.outerHTML.includes('iChart-datePickerSelector') && !SVG_ICONS['calendar'].includes(targetEle.outerHTML)  &&  !_this.ddDArrow.is(':hover') && _this.ddDArrowDiv[0] != targetEle) {
					ddDArrow.removeClass('a-clicked');	
					_this.options['datePicker'].hide();
				
			};
		});*/

		if (!cdata.agr || serie.options.db_type && serie.options.db_type == 'financial') {
			datePickerDiv.hide();
		};
		//END CALENDAR DATE PICKER

		//START ANNOTATIONS PICKER
		function annPickClick(e) {
			e.preventDefault();
			serie.menu.hide();

			annPickArrow.addClass('a-clicked');

			var pos = _this.userOptions.menu.calcDropDownPos(annPickDiv, _this.options['annotationPicker'].cnt);
			_this.options['annotationPicker'].toggle(pos);
		}

		var annPickDiv = _this.annPickDiv = div({}, {
			'id':'iChartHeader-annotationPicker-button',
			'title':'Add Annotations',
			// 'class': isDarkMode == true ? 'iChart-header-option iChartHeader-button dark-iChartHeader-annotationPicker-button d-sm-none-down' : 'iChart-header-option iChartHeader-button iChartHeader-annotationPicker-button d-sm-none-down',
		}).on('click', function (e) {
			_th.chart.navigationBindings.deselectAnnotation()
			annPickClick(e)
		});
		
		var annPickerSVG = $('<a href="#" class="iChart-headerTypeSelector iChart-annPickerSelector">' + SVG_ICONS[/*'addAnnotationSVG'*/'pencil_icon'] + '</a>')
		
		if(isDarkMode == true){
			annPickerSVG.addClass("dark-svg")
		}
		
		// annPickDiv.append(annPickerSVG);

		var annPickArrowDiv = _this.annPickArrowDiv = div({}, {
			'class': 'iChart-header-option-small d-none',
		}).on('click', function (e) {
			annPickClick(e);
		});

		var annPickArrow = _this.annPickArrow = $('<a href="#"></a>');

		annPickArrowDiv.append(annPickArrow);
		if(!isMobile){
			$(document).on('click', function (e) { /*Hiding Annotations Dropdown*/
			var targetEle = $(e.target)[0];
			if (_this.typeDiv[0] != targetEle && !_this.annPickDiv.is(':hover') && !_this.annPickArrow.is(':hover') && _this.annPickDiv[0] != targetEle) {
				ddTArrow.removeClass('a-clicked');
				_this.options['annotationPicker'].hide();
			};
		});
		}

		if (!cdata.agr || serie.options.db_type && serie.options.db_type == 'financial') {
			annPickDiv.hide();
		};
		//END Annotation PICKER

		var intervalDiv = _this.intervalDiv = div({}, {
			'id': isDarkMode == true ? 'dark-iChartHeader-interval-button' : 'iChartHeader-interval-button',
			'title':'Frequency',
			'class': !isMobile? 'iChart-header-option topnav-left-group iChartHeader-button iChartHeader-interval-button' : 'iChart-header-option topnav-left-group iChartHeader-button iChartHeader-interval-button interval-button-mobile'
		}).on('click', function (e) {
			_th.chart.navigationBindings.deselectAnnotation()
			if (cdata.compareNumber ==1) {
				iClick(e);
			}
			else{
				e.preventDefault();
			}
		});

		function iClick(e) {
			e.preventDefault();
			serie.menu.hide();
			
			ddIArrow.toggleClass('a-clicked');

			var pos = _this.userOptions.menu.calcDropDownPos(intervalDiv, _this.options['interval'].cnt);
			_this.options['interval'].toggle(pos);
		}
		
	//	if(INTERVALS[cdata.agr] == 'undefined'){
		if(serieDbType.toLowerCase() == 'stocks' || serieDbType.toLowerCase() == 'stock'){
			INTERVALS = STOCK_INTERVALS
		}
		var interval = _this.interval = $('<a id="intv-btn" href="#">' + (INTERVALS[cdata.agr].hasOwnProperty('display') ? INTERVALS[cdata.agr].display : cdata.agr) + ' ' + '</a>');
		intervalDiv.append(interval);

		var ddIArrowDiv = _this.ddIArrowDiv = div({}, {
			'class': 'iChart-header-option-small ddIArrowDiv d-none',
		}).on('click', function (e) {
			iClick(e);
		});

		var ddIArrow = _this.ddArrowInterval = $('<a href="#"></a>');

		ddIArrowDiv.append(ddIArrow);

		$(document).on('click', function (e) { /*Hiding Interval Dropdown*/
			var container = $("#iChart-dpMenu-cnt-interval");
			if (!container.is(e.target) && container.has(e.target).length === 0 && e.target.id != 'iChartHeader-interval-button' && e.target.id != 'dark-iChartHeader-interval-button' && e.target.id != 'intv-btn') 
    	{
        container.hide();
		ddIArrow.removeClass('a-clicked');
		_this.options['interval'].hide();
    	}
			if(e.target.id == 'intv-options'){
				container.hide()
			}
		});

		if (!cdata.agr || serie.options.db_type && serie.options.db_type == 'financial') {
			intervalDiv.hide();
		};

		// trigger dropdown type menu
		function tClick(e) {
			e.preventDefault();
			serie.menu.hide();

			ddTArrow.toggleClass('a-clicked');

			var pos = _this.userOptions.menu.calcDropDownPos(typeDiv, _this.options['type'].cnt);
			_this.options['type'].toggle(pos);
		};

		var typeDiv = _this.typeDiv = div({}, {
			'id': isDarkMode == true ? 'dark-iChartHeader-type-button' : 'iChartHeader-type-button',
			'title':'Chart Types',
			'class': 'iChart-header-option topnav-left-group iChartHeader-button iChartHeader-type-button d-sm-none-down',
			'style': nSeries > 2 ? '' : ''
		}).on('click', function (e) {
			_th.chart.navigationBindings.deselectAnnotation()

			if (cdata.compareNumber ==1) {
				$('.intVal').hide();
				tClick(e);
			}
			else {
				e.preventDefault();
			}
		});

		var type = _this.type = $('<a href="#" class="iChart-headerTypeSelector" style="margin: 0 !important;">' + `${!isMobile? SVG_ICONS[/*'chart_' + */serie.type + '_chart'] : SVG_ICONS[serie.type + '_chart_mobile']}` + '</a>');

		if(isDarkMode == true){
			type.addClass("dark-svg")
		}

		if (nSeries > 2) {
      $("#iChartHeader-interval-button").removeClass(
        "iChartHeader-interval-button"
      );
      $("#iChartHeader-type-button").removeClass("iChartHeader-type-button");
      $(".iChart-plotLabel").hide();
      $(".closeLine").hide();
      //$('.iChart-menu-cnt-labels').addClass('disabled');

      if (isMobile) {
        $(".iChart-control-bar-wrapper").css("margin", "0");
      }
      //fabio
	  $('#eventsBtn').addClass('disabled');
	  $('#dark-eventsBtn').addClass('disabled');
	  $('#eventsMenuOption').addClass('disabled');
      if (isDarkMode == true) {
        $("#dark-iChartHeader-type-button").addClass("disabled");
        $("#dark-iChartHeader-type-button").removeClass(
          "iChartHeader-type-button"
        );

        $("#dark-iChartHeader-interval-button").addClass("disabled");
        $("#dark-iChartHeader-interval-button").removeClass(
          "iChartHeader-interval-button"
        );

        $(".dark-iChart-headerLabel-name-input").addClass("disabled");
      } else {
        $("#iChartHeader-interval-button").addClass("disabled");
        $("#iChartHeader-type-button").addClass("disabled");
        $(".iChart-headerLabel-name-input").addClass("disabled");
      }
    }

		typeDiv.append(type);

		var ddTArrowDiv = _this.ddTArrowDiv = div({}, {
			'class': 'iChart-header-option-small ddTArrowDiv d-sm-none-down d-none'
		}).on('click', function (e) {
			tClick(e);
		});

		var ddTArrow = _this.ddArrowType = $('<a href="#"></a>');

		ddTArrowDiv.append(ddTArrow);



		$(document).on('click', function (e) { /*Hiding Type Dropdown*/
			var targetEle = $(e.target)[0];

			if (_this.typeDiv[0] != targetEle && !_this.type.is(':hover') && !_this.ddArrowType.is(':hover') && _this.ddTArrowDiv[0] != targetEle) {

				ddTArrow.removeClass('a-clicked');
				_this.options['type'].hide();
			};
		});

		_this.menu = $('<div></div>').on('click', function (e) {
			e.preventDefault();
			var aux;

			if (aux = serie.menu) {
				var pos = _this.userOptions.menu.calcDropDownPos(_this.menu, aux.cnt);
				aux.toggle({
					top: 0 + aux.cnt.outerHeight(),
					left: pos.left < 0 ? 0 : pos.left
				});
			}
		});

		for (var key in _this.options) {
			_this.options[key].update(serie, cdata);
		}
		this.cnt.append(inputGroup)
		// this.cnt.append(name).append(inputGroup); /*Main Search Input*/


		if (nSeries > 2) {
			
				$('#iChart-bodyLabels-cnt').addClass('settingsMenuBtn iChart-bodyLabels-cnt')
					//.css('width', '47%')
					//.css('border', '1px solid rgb(217, 218, 219)')
					.on('click', function(e) { showSeriesMenu(e, '#iChart-bodyLabels-cnt') })
				$('#iChart-bodyLabels-cnt2').addClass('settingsMenuBtn iChart-bodyLabels-cnt').on('click', function(e) { showSeriesMenu(e, '#iChart-bodyLabels-cnt2') })
				$('#iChart-bodyLabels-cnt3').addClass('settingsMenuBtn iChart-bodyLabels-cnt').on('click', function(e) { showSeriesMenu(e, '#iChart-bodyLabels-cnt3') })
				$('#iChart-bodyLabels-cnt4').addClass('settingsMenuBtn iChart-bodyLabels-cnt').on('click', function(e) { showSeriesMenu(e, '#iChart-bodyLabels-cnt4') })
				$('#iChart-bodyLabels-cnt5').addClass('settingsMenuBtn iChart-bodyLabels-cnt').on('click', function(e) { showSeriesMenu(e, '#iChart-bodyLabels-cnt5') })

				if(isDarkMode == true){
					$('#iChart-bodyLabels-cnt').removeClass('settingsMenuBtn')	
					$('#iChart-bodyLabels-cnt2').removeClass('settingsMenuBtn')
					$('#iChart-bodyLabels-cnt3').removeClass('settingsMenuBtn')
					$('#iChart-bodyLabels-cnt4').removeClass('settingsMenuBtn')
					$('#iChart-bodyLabels-cnt5').removeClass('settingsMenuBtn')

					$('#iChart-bodyLabels-cnt').addClass('dark-cnt dark-settingsMenuBtn')	
					$('#iChart-bodyLabels-cnt2').addClass('dark-cnt dark-settingsMenuBtn')
					$('#iChart-bodyLabels-cnt3').addClass('dark-cnt dark-settingsMenuBtn')
					$('#iChart-bodyLabels-cnt4').addClass('dark-cnt dark-settingsMenuBtn')
					$('#iChart-bodyLabels-cnt5').addClass('dark-cnt dark-settingsMenuBtn')
				}
		}
		else {
			$('#iChart-bodyLabels-cnt')
			.addClass('iChart-bodyLabels-cnt')
			.removeClass('settingsMenuBtn dark-settingsMenuBtn')
			.css('width', 'fit-content')
			.css('border', '0')		

			if(isDarkMode == true){
				$('#iChart-bodyLabels-cnt').addClass('dark-cnt')					
				}
		}

		if(isMobile && nSeries > 2){
			if(isDarkMode == true ){
				$('#iChart-bodyLabels-cnt').css('background-color', 'rgb(20,20,20)')
				$('#iChart-bodyLabels-cnt2').css('background-color', 'rgb(20,20,20)')
				$('#iChart-bodyLabels-cnt3').css('background-color', 'rgb(20,20,20)')
				$('#iChart-bodyLabels-cnt4').css('background-color', 'rgb(20,20,20)')
				$('#iChart-bodyLabels-cnt5').css('background-color', 'rgb(20,20,20)')
			}else{
				$('#iChart-bodyLabels-cnt').css('border', '1px solid rgb(217, 218, 219)')
				$('#iChart-bodyLabels-cnt2').css('border', '1px solid rgb(217, 218, 219)')
				$('#iChart-bodyLabels-cnt3').css('border', '1px solid rgb(217, 218, 219)')
				$('#iChart-bodyLabels-cnt4').css('border', '1px solid rgb(217, 218, 219)')
				$('#iChart-bodyLabels-cnt5').css('border', '1px solid rgb(217, 218, 219)')
			}
		}else if(isMobile && nSeries <= 2){
			$('#iChart-bodyLabels-cnt').css('border', '0px solid rgb(217, 218, 219)')
		}
		

		function showSeriesMenu(e, selector) {
			e.preventDefault();

			if (!_this.serie.options) return;
			if(!$(selector).hasClass(_this.serie.options.id)) return;

			var aux;

			if (aux = serie.menu) {
				var pos = _this.userOptions.menu.calcDropDownPos(_this.menu, aux.cnt);
				aux.toggle({
					top: 0 + aux.cnt.outerHeight(),
					left: pos.left < 0 ? 0 : pos.left
				});
			}




			//Add currently selected Y axis css
			if (_this.serie.yAxis.userOptions.id == 'y_axis_main') {
				for (var i in $('.axisPickWrapper span')) {

					if($('.axisPickWrapper span')[i].id == 'invertR-' + _this.serie.options.id) {
						if(isDarkMode == true){
							$($('.axisPickWrapper span')[i]).css('background-color', 'rgb(90, 90, 90)');
						}else{
							$($('.axisPickWrapper span')[i]).css('background-color', '#eee');
						}
					}
				}
			}
			else if (_this.serie.yAxis.userOptions.id == 'yaxis_n') {
				for (var i in $('.axisPickWrapper span')) {

					if($('.axisPickWrapper span')[i].id == 'invertN-' + _this.serie.options.id) {
						if(isDarkMode == true){
						$($('.axisPickWrapper span')[i]).css('background-color', 'rgb(90, 90, 90)');
						}else{
							$($('.axisPickWrapper span')[i]).css('background-color', '#eee');

						}
					}
				}
			}
			else if (_this.serie.yAxis.userOptions.id == 'y_axis_2') {
				for (var i in $('.axisPickWrapper span')) {

					if($('.axisPickWrapper span')[i].id == 'invertL-' + _this.serie.options.id) {
						if(isDarkMode == true){
							$($('.axisPickWrapper span')[i]).css('background-color', 'rgb(90, 90, 90)');
						}else{
							$($('.axisPickWrapper span')[i]).css('background-color', '#eee');
						}

					}
				}
			}
		}

		$(document).on('click', function (e) { /*Hiding Menu*/
			var element = $(e.target)[0];

			var isInside = false;
			
			var menuArr = document.querySelectorAll('.iChart-serie-menu');
			var labelsBtns = document.getElementById('iChart-bodyLabels-cntx');
			var iChartPopupArr = document.querySelectorAll('.iChart-Popup');

			for (var menu of menuArr) {
				if (element == menu || menu.contains(element)) {
					isInside = true;
				}
			}

			if (element == labelsBtns || labelsBtns.contains(element)) {
				isInside = true;
			}
			
			if (!isInside) {
				//console.log('HIDE MENU');
				for (var popUp of iChartPopupArr) $(popUp).hide();
			}
			else  { /*console.log('DO NOT HIDE MENU');*/ }
		});




		if(cdata.bs.split(',')[0] == serie.options.id){
			// this.cnt.append(intervalDiv);
			// this.cnt.append(ddIArrowDiv);
			// this.cnt.append(typeDiv);
			// this.cnt.append(ddTArrowDiv);
			// this.cnt.append(datePickerDiv);
			// this.cnt.append(ddDArrowDiv);
			if(!isMobile){
				// this.cnt.append(annPickDiv);
				if ($('#iChartHeader-annotationPicker-button').length) {
					$('#iChartHeader-annotationPicker-button').remove()
				}
				$('.topnav-flex-container').prepend(annPickDiv)
				// this.cnt.append(annPickArrowDiv);
			}
			if ($('.ddDArrowDiv').length) {
				$('.ddDArrowDiv').remove()
			}
			$('.topnav-flex-container').prepend(ddDArrowDiv)
			if ($('.iChartHeader-datePicker-button').length) {
				$('.iChartHeader-datePicker-button').remove()
			}
			$('.topnav-flex-container').prepend(datePickerDiv)
			if ($('.ddTArrowDiv').length) {
				$('.ddTArrowDiv').remove()
			}
			$('.topnav-flex-container').prepend(ddTArrowDiv)
			if ($('#iChartHeader-type-button').length) {
				$('#iChartHeader-type-button').remove()
			}
			if ($('#dark-iChartHeader-type-button').length) {
				$('#dark-iChartHeader-type-button').remove()
			}
			$('.topnav-flex-container').prepend(typeDiv)
			if ($('.ddIArrowDiv').length) {
				$('.ddIArrowDiv').remove()
			}
			$('.topnav-flex-container').prepend(ddIArrowDiv)
			if ($('#iChartHeader-interval-button').length) {
				$('#iChartHeader-interval-button').remove()
			}
			if ($('#dark-iChartHeader-interval-button').length) {
				$('#dark-iChartHeader-interval-button').remove()
			}
			$('.topnav-flex-container').prepend(intervalDiv)
			if ($('.expand-search').length) {
				$('.expand-search').remove()
			}
			$('.topnav-flex-container').prepend(name)
		}
		this.cnt.show();
	},

	updateSerie: function updateSerie(updateType, value, value2) {
		var _this = this;
	
		if (_this.userOptions.menu.options.Add != undefined && !isUpdate) _this.userOptions.menu.options.Add.cnt.hide();

		//if (_this.userOptions.menu.config.bodyLabels) _this.userOptions.menu.options.bodyLabels.cnt.hide();

		if (_this.expandedSearch) _this.expandedSearch.remove();

		switch (updateType) {
			case 'type':
				_this.userOptions.menu.events.typeChange(value);
				_this.type.empty().append(`${!isMobile? SVG_ICONS[/*'chart_' + */value + '_chart'] : SVG_ICONS[value + '_chart_mobile']}`);
				break;

			case 'interval':
				if (!value) {
					_this.interval.hide();
					break;
				}
				_this.interval.show();
				_this.userOptions.menu.events.intervalChange(value);
				break;

			case 'bs':
				_this.userOptions.menu.events.replaceSymbol(value, value2);
				break;

			case 'interval_span':
				_this.userOptions.menu.events.intervalSpanChange(value, value2);
				break;

			case 'date_picker':		
				_this.userOptions.menu.events.datePickerChange(value, value2);
				break;
		}
	},

	hide: function hide() {
		this.cnt.hide();
	},

	show: function show() {
		this.cnt.show();
	},

	remove: function remove() {
		if (nSeriesGlobal <= 3) saveUserSelections = {};
		this.cnt.remove();
	}
};

function HeaderLabel_type(options, updateSerie) {
	var _this = this,
	    type = {};

	type.cnt = div({}, {
		'id': 'iChart-dpMenu-cnt-type',
		'class': isDarkMode == true ? 'iChart-dpMenu-cnt darkSubTopMenu' : 'iChart-dpMenu-cnt'
	});

	type.toggle = function (pos) {
		if (this.cnt.is(':visible')) {
			this.hide();
		} else {
			this.show(pos);
		}
	};

	type.show = function (pos) {
		_this.options['datePicker'].hide();
		_this.options['type'].hide();
		_this.options['interval'].hide();
		if(!isMobile){_this.options['annotationPicker'].hide();}
		pos = {
			top: '40px',
			left: '273px'
		};
		const left = isDarkMode? document.getElementById('dark-iChartHeader-type-button').getBoundingClientRect().left : document.getElementById('iChartHeader-type-button').getBoundingClientRect().left
		const leftOffset = !isFS? left - document.getElementById('trading_chart').getBoundingClientRect().left : left
		const leftPos = window.innerWidth > 480? leftOffset - 3 : leftOffset - 12
		pos.left = leftPos + 'px'
		this.cnt.css(pos);
		this.cnt.show();
	};
	
	type.hide = function () {
		this.cnt.hide();
};

	type.update = function (serie) {
		if (!serie) {
			return;
		}
		//update options icons

		var types = serie.userOptions.allowedTypes || [];
		this.cnt.empty();
		types = ['line', 'area', 'candlestick', 'ohlc'];
		for (var i = 0; i < types.length; i++) {
			var a = $('<a data-type="' + types[i] + '">' + `${!isMobile? SVG_ICONS[/*'chart_' + */types[i] + '_chart'] : SVG_ICONS[types[i] + '_chart_mobile']}` || '' + '</a>').on('click', function (e) {
				e.preventDefault();
				saveAnnotationsAutomatically(false)
				lastType = $(this).attr('data-type');
				var newType = $(this).attr('data-type');
				currentChartType = newType
				updateSerie('type', newType);
			});
			if(isDarkMode == true){
				a.addClass('dark-svg')
			}

			type.cnt.append(a);
		}
	};

	options.chartWrapper.append(type.cnt);
	_this.options['type'] = type;
};

function HeaderLabel_interval(options, updateSerie) {

	/*Interval Change Function > min | hrs | day | week | month */
	var _this = this,
	    interval = {};

			interval.cnt = div({}, {
				'id': 'iChart-dpMenu-cnt-interval',
				'class': isDarkMode == true ? 'iChart-dpMenu-cnt intVal darkSubTopMenu' : 'iChart-dpMenu-cnt intVal', 
			});

	interval.toggle = function (pos) {
		if (this.cnt.is(':visible')) {
			this.hide();
		} else {
			this.show(pos);
		}
	};

	interval.show = function (pos) {
		_this.options['datePicker'].hide();
		_this.options['type'].hide();
		_this.options['interval'].hide();
		if(!isMobile){_this.options['annotationPicker'].hide();}
		if (!pos) {
			pos = {
				top: '0',
				left: '0'
			};
		}
		if(!isMobile){
			pos = {top: '40px', left: '198px'};
		}else{
			pos = {top: '40px', left: '36px'};
		}
		const left = isDarkMode? document.getElementById('dark-iChartHeader-interval-button').getBoundingClientRect().left : document.getElementById('iChartHeader-interval-button').getBoundingClientRect().left
		const leftOffset = !isFS? left - document.getElementById('trading_chart').getBoundingClientRect().left : left
		const is_intraday = _th.config.cdata.allow_intraday
		const leftPos = is_intraday? leftOffset - 25 : leftOffset - 17
		pos.left = leftPos + 'px'
		this.cnt.css(pos);
		this.cnt.show();
	};

	interval.hide = function () {
		this.cnt.hide();
	};

	interval.update = function (serie, cdata) {
		var isInaccessible;//bruno
		let interval_list = [];
		if(allowed_interval != null || allowed_interval != undefined) { //bruno
			isInaccessible = true;
		}
		if (!serie) {
			return;
		}

		var currentInterval = cdata.agr || cdata.allow_interval;

		this.cnt.empty();

		let dynCls = "";
		
		if(serieDbType.toLowerCase() == 'stocks' || serieDbType.toLowerCase() == 'stock'){
			INTERVALS = STOCK_INTERVALS
		}

		for (var key in INTERVALS) {

			var aux = INTERVALS[key];

			if (allowed_interval && aux.id == allowed_interval.toLowerCase()) {
				isInaccessible = false;
			};
			if(has_intraday == false) {
				cdata.allow_intraday = false
			}

			if(allowed_interval == null || allowed_interval == undefined) {
				isInaccessible = cdata.allow_intraday == true ? false : aux.intraday == true;
			}

			if(forceIntraday == true){
				isInaccessible = false
			}

			let b;
			var expandFunction = function auxFn(e, findClass) {
				var tgt = $(e.target);
				var group = $( "." + findClass );
				tgt.toggleClass('icon-down', 'icon-up');
				group.toggleClass( "d-none" );
			};

			if((aux.id.indexOf('m') != -1 || aux.id.indexOf('h') != -1) && aux.id.indexOf('month') == -1 && interval_list.indexOf('m') === -1 && !isInaccessible){
				dynCls = 'minuteInterval';
				interval_list.push('m');
				if(isDarkMode == true){
					b = $('<a class="dark-intervalExpand icon-up">Intraday</a>').on('click', function (e) { expandFunction(e, 'minuteInterval') });
				}else{
					b = $('<a class="intervalExpand icon-up">Intraday</a>').on('click', function (e) { expandFunction(e, 'minuteInterval') });
				}
			}
			
			/*if(aux.id.indexOf('h') != -1 && aux.id.indexOf('month') == -1 && interval_list.indexOf('h') === -1 && !isInaccessible){
				dynCls = 'hourInterval';
				interval_list.push('h');
				b = $('<a class="intervalExpand icon-up">Hours</a>').on('click', function (e) { expandFunction(e, 'hourInterval') });
			}*/
			if(aux.id.indexOf('d') != -1 && interval_list.indexOf('d') === -1 && !isInaccessible){
				dynCls = 'dayInterval';
				interval_list.push('d');
				
				if(isDarkMode == true){
					b = $('<a class="dark-intervalExpand icon-up">Days</a>').on('click', function (e) { expandFunction(e, 'dayInterval') });
				}else{
					b = $('<a class="intervalExpand icon-up">Days</a>').on('click', function (e) { expandFunction(e, 'dayInterval') });
				}
			}
			this.cnt.append(b);

			var auxFn = function auxFn(e) {
				e.preventDefault();
				resetAnnotations(true);
				updateSerie('interval_span', $(this).attr('data-interval'), $(this).attr('data-span'));
			};

			var a = $('<a id="intv-options" class="iChart-dpMenu-interval ' + dynCls + '" data-span="' + aux.span + '" data-interval="' + aux.id + '" style="">' + aux.text + '</a>').on('click', isInaccessible ? function (e) {
				e.preventDefault();
				e.stopPropagation();
				$("#iChart-dpMenu-cnt-interval").hide()
				resetAnnotations(true);
			} : auxFn);
			this.cnt.append(a);

			if (aux.id == currentInterval) {
				if(isDarkMode == true){
					a.addClass('dark-iChart-active')
				}else{
					a.addClass('iChart-active');
				}
			};

			if (isInaccessible && forceIntraday != true) {
				a.addClass('iChart-hidden');
			}
		} //end for
	};

	options.chartWrapper.append(interval.cnt);
	_this.options['interval'] = interval;
};

function HeaderLabel_calendar(options, updateSerie) {
	var _this = this,
	    datePicker = {};

			datePicker.cnt = div({}, {
		'id': isDarkMode == true ? 'dark-iChart-dpMenu-cnt-date' : 'iChart-dpMenu-cnt-date',
		'class': 'iChart-dpMenu-cnt iChart-dpMenu-cnt-date'
	});

	datePicker.toggle = function (pos) {
		if (this.cnt.is(':visible')) {
			this.hide();
		} else {
			this.show(pos);

		}
	};

	datePicker.show = function (pos) {
		_this.options['datePicker'].hide();
		_this.options['type'].hide();
		_this.options['interval'].hide();
		if(!isMobile){_this.options['annotationPicker'].hide();}
		if(!isMobile){
			pos = {
				top: '40px',
				left: '264px',
				display: 'flex'
			};
		}else{
			pos = {
				top: '40px',
				left: '79px',
				display: 'flex'
			};
		}

		const left = isDarkMode? document.getElementById('dark-iChartHeader-datePicker-button').getBoundingClientRect().left : document.getElementById('iChartHeader-datePicker-button').getBoundingClientRect().left
		const leftOffset = !isFS? left - document.getElementById('trading_chart').getBoundingClientRect().left : left
		const leftPos = window.innerWidth > 480? leftOffset - 66 : leftOffset - 71
		pos.left = leftPos + 'px'

		this.cnt.css(pos);
		this.cnt.show();
	};

	datePicker.hide = function () {
		this.cnt.hide();
	};

	datePicker.update = function (serie, cdata) {
		if (!serie || cdata.d1 != null || cdata.d2 != null) {
			return;
		}

		this.cnt.empty();
		var calendarMin=''

		if(typeof TEChartsMeta !== 'undefined' && TEChartsMeta.length > 0 && TEChartsMeta[0].first_date ){
			calendarMin = parseInt(TEChartsMeta[0].first_date.split('(')[1].split(')')[0])
			calendarMin = new Date(calendarMin).toISOString().slice(0,10)
			if(new Date(calendarMin)=='Invalid Date'){
				calendarMin = new Date(serie.xData[0]).toISOString().slice(0,10)
			}
		}else{
			calendarMin = new Date(serie.xData[0]).toISOString().slice(0,10)
		}
			var calendarStart = new Date(serie.xData[0]).toISOString().slice(0,10)
			var calendarEnd = new Date(serie.xData[serie.xData.length-1]).toISOString().slice(0,10)

			const base_series_start = new Date(_th.chart.series[0].data[0].x).toISOString().slice(0,10)
			const base_series_end = new Date(_th.chart.series[0].data[_th.chart.series[0].data.length-1].x).toISOString().slice(0,10)
			if (new Date(calendarMin) > new Date(base_series_start)) {
				calendarMin = base_series_start
			}
			if (new Date(calendarEnd) < new Date(base_series_end)) {
				calendarEnd = base_series_end
			}

			function datePickerRules() {
        if (
          new Date($("#start").val()) < new Date(calendarMin) ||
          new Date($("#start").val()) > new Date(calendarEnd) ||
          new Date($("#start").val()) == "Invalid Date" ||
          $("#start").val().length != 10 ||
          new Date($("#start").val()) >= new Date($("#end").val())
        ) {
          $("#start").addClass("input-error");
        } else {
					var startMonth = parseInt($("#start").val().split('-')[1])
					var startDay = parseInt($("#start").val().split('-')[2])
					
					if(((startMonth == 1 || startMonth == 3 || startMonth == 5 || startMonth == 7 || startMonth == 8 || startMonth == 10 || startMonth == 12)  && startDay <= 31) || (startMonth == 2 && startDay <= 28) || (startMonth == 4 && startDay <= 30) || (startMonth == 6 && startDay <= 30)|| (startMonth == 9 && startDay <= 30) || (startMonth == 11 && startDay <= 30)){
						$("#start").removeClass("input-error");
					}else{
						$("#start").addClass("input-error");
					}
        }

        if (
          new Date($("#end").val()) < new Date(calendarMin) ||
          new Date($("#end").val()) > new Date(calendarEnd) ||
          new Date($("#end").val()) == "Invalid Date" ||
          $("#start").val().length != 10 ||
          new Date($("#end").val()) <= new Date($("#start").val())
        ) {
          $("#end").addClass("input-error");
        } else {
					var endMonth = parseInt($("#end").val().split('-')[1])
					var endDay = parseInt($("#end").val().split('-')[2])
					
					if(((endMonth == 1 || endMonth == 3 || endMonth == 5 || endMonth == 7 || endMonth == 8 || endMonth == 10 || endMonth == 12) && endDay <= 31) || (endMonth == 2 && endDay <= 28) || (endMonth == 4 && endDay <= 30) || (endMonth == 6 && endDay <= 30)|| (endMonth == 9 && endDay <= 30) || (endMonth == 11 && endDay <= 30)){
						$("#end").removeClass("input-error");
					}else{
						$("#end").addClass("input-error");
					}
        }

        if (
          new Date($("#end").val()) < new Date(calendarMin) ||
          new Date($("#end").val()) > new Date(calendarEnd) ||
          new Date($("#start").val()) < new Date(calendarMin) ||
          new Date($("#start").val()) > new Date(calendarEnd) ||
          $("#start").val().length != 10 ||
          $("#end").val().length != 10 ||
          new Date($("#start").val()) == "Invalid Date" ||
          new Date($("#end").val()) == "Invalid Date" ||
          new Date($("#start").val()) >= new Date($("#end").val()) ||
          new Date($("#end").val()) <= new Date($("#start").val())
        ) {
					$("#btnOK").attr("disabled", true);			
        } else {
					$("#btnOK").attr("disabled", false);	

					var endMonth = parseInt($("#end").val().split('-')[1])
					var endDay = parseInt($("#end").val().split('-')[2])
					var startMonth = parseInt($("#start").val().split('-')[1])
					var startDay = parseInt($("#start").val().split('-')[2])

			
					if((startMonth == 2 && startDay > 28) || (startMonth == 4 && startDay > 30) || (startMonth == 6 && startDay > 30)|| (startMonth == 9 && startDay > 30) || (startMonth == 11 && startDay > 30)){
						$("#btnOK").attr("disabled", true);
					}

					if((endMonth == 2 && endDay > 28) || (endMonth == 4 && endDay > 30) || (endMonth == 6 && endDay > 30)|| (endMonth == 9 && endDay > 30) || (endMonth == 11 && endDay > 30)){			
						$("#btnOK").attr("disabled", true);
					}

        
        }
      }


			var input_start = $('<input type="text" title="Start (YYYY-MM-DD)" id="start" name="trip-start" value="' + calendarStart + '" min="' + calendarMin + '" max="'+ calendarEnd +'" required pattern="(?:19|20)\[0-9\]{2}-(?:(?:0\[1-9\]|1\[0-2\])/(?:0\[1-9\]|1\[0-9\]|2\[0-9\])|(?:(?!02)(?:0\[1-9\]|1\[0-2\])/(?:30))|(?:(?:0\[13578\]|1\[02\])-31))">')
			datePicker.cnt.append(input_start);

			$('#start').on('change', function() {
				datePickerRules()
		}).on('keyup', function() {
			datePickerRules()
		}).on('keydown', function() {
			datePickerRules()
		});

			var input_end = $('<input type="text" id="end" title="End (YYYY-MM-DD)" name="trip-end" value="'+ calendarEnd +'" min="' + calendarMin + '" max="'+ calendarEnd +'" required pattern="(?:19|20)\[0-9\]{2}-(?:(?:0\[1-9\]|1\[0-2\])/(?:0\[1-9\]|1\[0-9\]|2\[0-9\])|(?:(?!02)(?:0\[1-9\]|1\[0-2\])/(?:30))|(?:(?:0\[13578\]|1\[02\])-31))">')
			datePicker.cnt.append(input_end);

			$('#end').change(function() {
				datePickerRules()
		}).on('keyup', function() {
			datePickerRules()
		}).on('keydown', function() {
			datePickerRules()
		});

			var date_ok = $('<button id="btnOK" type="button">Submit</button>').on('click', function (e) {
				e.preventDefault()
				ga('event', 'te_chart_markets_datepicker');
				saveAnnotationsAutomatically(true)
				var start = input_start.val();
				var end = input_end.val();

				updateSerie('date_picker', start, end);
				datePicker.cnt.hide();
			});
			datePicker.cnt.append(date_ok);	
			
		};

		options.chartWrapper.append(datePicker.cnt);

	_this.options['datePicker'] = datePicker;
};

$(document).on('click', function (e) { /*Hiding Calendar Container*/
var container = $("#iChart-dpMenu-cnt-date");
var container2= $("#iChartHeader-datePicker-button")

if(isDarkMode == true){
	container = $("#dark-iChart-dpMenu-cnt-date");
	container2= $("#dark-iChartHeader-datePicker-button")
}

if (!container.is(e.target) && container.has(e.target).length === 0 && !$(e.target).closest(container2).length) 
{
	container.hide();
}
});

function HeaderLabel_annotations(options) {
	var _this = this,
	    annotationPicker = {};

			annotationPicker.cnt = div({}, {
		'id': 'iChart-dpMenu-cnt-annotation',
		'class': isDarkMode == true ? 'iChart-dpMenu-cnt darkSubTopMenu dark-stroke-svg' : 'iChart-dpMenu-cnt'
	});

	annotationPicker.toggle = function (pos) {
		if (this.cnt.is(':visible')) {
			this.hide();
		} else {
			this.show(pos);

		}
	};

	annotationPicker.show = function (pos) {
		_this.options['datePicker'].hide();
		_this.options['type'].hide();
		_this.options['interval'].hide();
		if(!isMobile){_this.options['annotationPicker'].hide();}

			pos = {
				top: '40px',
				left: '425px',
			};
		
		
		this.cnt.css(pos);
		this.cnt.show();
	};

	annotationPicker.hide = function () {
		this.cnt.hide();
	};

	annotationPicker.update = function (serie, cdata) {
		if (!serie) {
			return;
		}

		this.cnt.empty();

		var types = ['trendline', 'horizontal line', 'vertical line', 'text annotation'];
		for (var i = 0; i < types.length; i++) {
			var a = $('<a title="Draw '+ types[i] +'" data-type="' + types[i] + '">' + SVG_ICONS[types[i]] + '</a>').on('click', function (e) {
				e.preventDefault();	

				if($(this).attr('data-type') === 'trendline') {
					var a = $(".highcharts-segment");
					a.click();
					$("#iChartHeader-annotationPicker-button").addClass("draw-trendline-active")
					$("#control-bar-wrapper").css("display","none")
					_th.chart.update({ plotOptions : {line: {states: {hover: {enabled: false,}} } }});						
			}else if($(this).attr('data-type') === 'horizontal line'){
				e.preventDefault()
				_th.chart.navigationBindings.deselectAnnotation()
				if($(".draw-horizontalline-active").is(":visible")){
					$("#iChartHeader-annotationPicker-button").removeClass("draw-horizontalline-active")
					$('.iChart-chart').css('cursor','default')	
					$("#control-bar-wrapper").css("display","block")
				}else{
					$('.iChart-chart').css('cursor','crosshair')	
					$("#iChartHeader-annotationPicker-button").addClass("draw-horizontalline-active")
					$("#control-bar-wrapper").css("display","none")
				}
				_th.chart.update({ plotOptions : {line: {states: {hover: {enabled: false,}} } }});
			}else if($(this).attr('data-type') === 'vertical line'){
				e.preventDefault()
				_th.chart.navigationBindings.deselectAnnotation()
				if($(".draw-verticalline-active").is(":visible")){
					$("#iChartHeader-annotationPicker-button").removeClass("draw-verticalline-active")
					$('.iChart-chart').css('cursor','default')	
					$("#control-bar-wrapper").css("display","block")

				}else{
					$('.iChart-chart').css('cursor','crosshair')	
					$("#iChartHeader-annotationPicker-button").addClass("draw-verticalline-active")
					$("#control-bar-wrapper").css("display","none")
				}
				_th.chart.update({ plotOptions : {line: {states: {hover: {enabled: false,}} } }});
			} else if ($(this).attr('data-type') === 'text annotation') {
				$("#iChartHeader-annotationPicker-button").addClass("draw-textannotation-active")
				$("#control-bar-wrapper").css("display","none")
				let a = $(".highcharts-label-annotation")
				a.click();
			}
				annotationPicker.cnt.hide()			
			});
			if(isDarkMode == true){
				a.addClass('dark-svg')
			}
			annotationPicker.cnt.append(a);
		}	
		};

		options.chartWrapper.append(annotationPicker.cnt);

	_this.options['annotationPicker'] = annotationPicker;
};

//Click events related with trendline
$(document).on('click', function (e) {
	if($(".draw-trendline-active").is(":visible")){
		countToResetDraw ++
		if(countToResetDraw == 3){
			$('#iChartHeader-annotationPicker-button').removeClass("draw-trendline-active")
			_th.chart.update({ plotOptions : {line: {states: {hover: {enabled: true,}} } }});
			countToResetDraw = 0
			$("#control-bar-wrapper").css("display","block")
		}else{
			$("#control-bar-wrapper").css("display","none")
		}
	}
});

function checkSelectedTaskThruty(anno){
	if(anno.userOptions.langKey == 'segment'){
		return anno.userOptions.typeOptions.points[0].controlPoint.visible
	} else if (anno.userOptions.langKey.toLowerCase() == 'label') {
		if (anno.labels[0]) {
			if (anno.labels[0].controlPoints[0]) {
				return anno.labels[0].controlPoints[0].options.visible
			}
		}
	} else{
		return false
	}
}

$(document).on('mouseover', function (e) {
	if(_th.chart.annotations.length > 0){
		if($(".draw-trendline-active").is(":visible") === false && $(".draw-horizontalline-active").is(":visible") === false && $(".draw-verticalline-active").is(":visible") === false && $(".draw-textannotation-active").is(":visible") === false && $('.textannotation-popup-title').is(":visible") === false){
			if(_th.chart.annotations.some(checkSelectedTaskThruty)){
				$("#control-bar-wrapper").css("display","none")
			}else{
				$("#control-bar-wrapper").css("display","block")
			}
		}
	}
});
